"use client";
import React from "react";
import Lottie from "lottie-react";
const loading = () => {
  return (
    <div className="w-full h-[calc(100vh-8rem)] flex flex-col items-center justify-center bg-white">
      <Lottie
        animationData={require("@/public/animations/loader.json")}
        width={200}
        height={200}
        className="w-[200px] h-[200px] md:block hidden"
        color="white"
      />
      We Are Brewing Your Chai...
    </div>
  );
};

export default loading;
